import { render, staticRenderFns } from "./ConfiguracionFormularioHc.vue?vue&type=template&id=0fcefb56&scoped=true"
import script from "./ConfiguracionFormularioHc.vue?vue&type=script&lang=js"
export * from "./ConfiguracionFormularioHc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcefb56",
  null
  
)

export default component.exports